/** CoStar.Api.MarketAnalytics.SearchApi.Download.DocumentType */
export var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["CapitalMarketsDatasheetReport"] = 115] = "CapitalMarketsDatasheetReport";
})(DocumentType || (DocumentType = {}));
